import React, { useState } from 'react';

/* eslint-disable */
import { SubHeading, Menuitem } from '../../components';
import { data, images } from '../../constants';
import './SpecialMenu.css';
import Aos from "aos";
import "aos/dist/aos.css";

const SpecialMenu = () => {

  React.useEffect(() => {
    Aos.init();
  }, []);
  const [active, setActive] = useState("tacos");
  const setColor = (active) => {
    if (active == "tacos") {
      return "green";
    } else {
      return "yellow";
    }
  };
  return (
  <div className="app__specialMenu flex__center section__padding" id="menu" >
    <div className="app__specialMenu-title" data-aos="zoom-in">
      <SubHeading title="Choisissez Votre Menu" />
   <div classname='app__button__flex'>
    <button className={`tag${setColor(active)}`} type="button" onClick={() => setActive("tacos")}>
     Tacos 🌮
    </button>
    <button className='button' type="button" onClick={() => setActive("burger")}>
    Burger 🍔
    </button>
    <button className='button' type="button" onClick={() => setActive("naans")}>
     Naans 🌯
    </button>
    <button className='button' type="button" onClick={() => setActive("pizza")}>
     Pizza 🍕
    </button>
    <button  className='button' type="button" onClick={() => setActive("sandwish")}>
    Sandwishs🥪
    </button>
    <button  className='button' type="button" onClick={() => setActive("pates")}>
    Pates🍝🥗
    </button>
    <button  className='button' type="button" onClick={() => setActive("assietes")}>
    Assietes🍢
    </button>

  
  
    <button className='button' type="button" onClick={() => setActive("dessert et boisson")}>
     Dessert 🍩
    </button>
   </div>
    </div>

{active== 'pizza' &&(
 <div className="app__specialMenu-menu">
 <div className="app__specialMenu-menu_wine  flex__center">
   <p className="app__specialMenu-menu_heading">Pizza à Base Sauce Tomate</p>
   <div className="app__specialMenu_menu_items">
     {data.pizzaTomate.map((wine, index) => (
       <Menuitem key={wine.title + index} title={wine.title} price={wine.price} tags={wine.tags} />
     ))}
   </div>
 </div>

 <div className="app__specialMenu-menu_img">
   <img src={images.pizza} alt="menu__img" />
 </div>

 <div className="app__specialMenu-menu_cocktails  flex__center">
   <p className="app__specialMenu-menu_heading">Pizza à Base Créme Fraiche </p>
   <div className="app__specialMenu_menu_items">
     {data.pizzaFraiche.map((cocktail, index) => (
       <Menuitem key={cocktail.title + index} title={cocktail.title} price={cocktail.price} tags={cocktail.tags} />
     ))}
   </div>
 </div>
</div>

)

}


{active== 'pates' &&(
 <div className="app__specialMenu-menu">
 <div className="app__specialMenu-menu_wine  flex__center">
   <p className="app__specialMenu-menu_heading">Nos Pates</p>
   <div className="app__specialMenu_menu_items">
     {data.pates.map((wine, index) => (
       <Menuitem key={wine.title + index} title={wine.title} price={wine.price} tags={wine.tags} />
     ))}
   </div>
 </div>

 <div className="app__specialMenu-menu_img">
   <img src={images.pates} alt="menu__img" />
 </div>

 <div className="app__specialMenu-menu_cocktails  flex__center">
   <p className="app__specialMenu-menu_heading">Nos Salades </p>
   <div className="app__specialMenu_menu_items">
     {data.salades.map((cocktail, index) => (
       <Menuitem key={cocktail.title + index} title={cocktail.title} price={cocktail.price} tags={cocktail.tags} />
     ))}
   </div>
 </div>
</div>

)

}


{active=='naans' &&(
 <div className="app__specialMenu-menu">
 <div className="app__specialMenu-menu_wine  flex__center">
   <p className="app__specialMenu-menu_heading">Nos Cheese Naans:</p>
   <div className="app__specialMenu_menu_items">
     {data.naans.map((wine, index) => (
       <Menuitem key={wine.title + index} title={wine.title} price={wine.price} tags={wine.tags} />
     ))}
   </div>
 </div>

 <div className="app__specialMenu-menu_img">
   <img src={images.naans} alt="menu__img" />
 </div>
</div>

)

}
{active=='tacos' &&(
 <div className="app__specialMenu-menu">
 <div className="app__specialMenu-menu_wine  flex__center">
   <p className="app__specialMenu-menu_heading">Nos Tacos:</p>
   <div className="app__specialMenu_menu_items">
     {data.tacos.map((wine, index) => (
       <Menuitem key={wine.title + index} title={wine.title} price={wine.price} tags={wine.tags} />
     ))}
   </div>
 </div>

 <div className="app__specialMenu-menu_img">
   <img src={images.tacos} alt="menu__img" />
 </div>
</div>

)

}
{active=='burger' &&(
 <div className="app__specialMenu-menu">
 <div className="app__specialMenu-menu_wine  flex__center">
   <p className="app__specialMenu-menu_heading">Nos Burgers:</p>
   <div className="app__specialMenu_menu_items">
     {data.burger.map((wine, index) => (
       <Menuitem key={wine.title + index} title={wine.title} price={wine.price} tags={wine.tags} />
     ))}
   </div>
 </div>

 <div className="app__specialMenu-menu_img">
   <img src={images.burger} alt="menu__img" />
 </div>
</div>

)
}
{active=='assietes' &&(
 <div className="app__specialMenu-menu">
 <div className="app__specialMenu-menu_wine  flex__center">
   <p className="app__specialMenu-menu_heading">Nos Assietes:</p>
   <div className="app__specialMenu_menu_items">
     {data.assietes.map((wine, index) => (
       <Menuitem key={wine.title + index} title={wine.title} price={wine.price} tags={wine.tags} />
     ))}
   </div>
 </div>

 <div className="app__specialMenu-menu_img">
   <img src={images.assietes} alt="menu__img" />
 </div>
 <div className="app__specialMenu-menu_cocktails  flex__center">
   <p className="app__specialMenu-menu_heading">Nos Tex Mex et Paninis </p>
   <div className="app__specialMenu_menu_items">
     {data.paninis.map((cocktail, index) => (
       <Menuitem key={cocktail.title + index} title={cocktail.title} price={cocktail.price} tags={cocktail.tags} />
     ))}
   </div>
 </div>
</div>

)
}

{active== 'dessert et boisson' &&(
 <div className="app__specialMenu-menu">
 <div className="app__specialMenu-menu_wine  flex__center">
   <p className="app__specialMenu-menu_heading">Nos Desserts</p>
   <div className="app__specialMenu_menu_items">
     {data.dessert.map((wine, index) => (
       <Menuitem key={wine.title + index} title={wine.title} price={wine.price} tags={wine.tags} />
     ))}
   </div>
 </div>

 <div className="app__specialMenu-menu_img">
   <img src={images.tiramisu} alt="menu__img" />
 </div>

 <div className="app__specialMenu-menu_cocktails  flex__center">
   <p className="app__specialMenu-menu_heading">Nos Boissons </p>
   <div className="app__specialMenu_menu_items">
     {data.boisson.map((cocktail, index) => (
       <Menuitem key={cocktail.title + index} title={cocktail.title} price={cocktail.price} tags={cocktail.tags} />
     ))}
   </div>
 </div>
</div>

)

}
{active== 'sandwish' &&(
 <div className="app__specialMenu-menu">
 <div className="app__specialMenu-menu_wine  flex__center">
   <p className="app__specialMenu-menu_heading">Nos Kebab</p>
   <div className="app__specialMenu_menu_items">
     {data.kebab.map((wine, index) => (
       <Menuitem key={wine.title + index} title={wine.title} price={wine.price} tags={wine.tags} />
     ))}
   </div>
 </div>

 <div className="app__specialMenu-menu_img">
   <img src={images.kebab} alt="menu__img" />
 </div>

 <div className="app__specialMenu-menu_cocktails  flex__center">
   <p className="app__specialMenu-menu_heading">Nos Sandwish </p>
   <div className="app__specialMenu_menu_items">
     {data.sandwish.map((cocktail, index) => (
       <Menuitem key={cocktail.title + index} title={cocktail.title} price={cocktail.price} tags={cocktail.tags} />
     ))}
   </div>
 </div>
</div>

)

}
   


  </div>
)
          };

export default SpecialMenu;
